import { useSelector } from 'react-redux';
import { Alert } from '@pmi/dsm-react';
import { CircleInfoIcon } from '@pmi/dsm-react/dist/components/icons/16';
import { adminLayoutSelector } from '../../../Admin/adminLayoutSlice';

interface AdminPayByUserNotificationProps {
  agreementId: string;
}
export default function AdminPayByUserNotification({
  agreementId,
}: AdminPayByUserNotificationProps) {
  const { payByUserAgreements } = useSelector(adminLayoutSelector);
  if (payByUserAgreements.length > 0) {
    if (agreementId === 'all') {
      return (
        <Alert
          alertText={
            "This view excludes data from agreements classified as 'Pay by User'"
          }
          icon={CircleInfoIcon}
          variant="info"
        />
      );
    }
    const foundMessage =
      'This agreement is set up as Paid by your Users and is not included in your All Agreements totals due to your organization not being responsible for payment.';
    const message = payByUserAgreements.includes(agreementId) ? (
      <Alert alertText={foundMessage} icon={CircleInfoIcon} variant="info" />
    ) : null;
    return message;
  }
  return null;
}
